import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Role } from './roleTypes';

interface RoleState {
  roles: Role[];
  isLoading: boolean;
  error: string | null;
  isSuperadmin: boolean;
}

const initialState: RoleState = {
  roles: [],
  isLoading: true,
  error: null,
  isSuperadmin: false,
};

const roleSlice = createSlice({
  name: 'roles',
  initialState,
  reducers: {
    setRoles(state, action: PayloadAction<Role[]>) {
      return { ...state, roles: action.payload, isLoading: true }; // Set roles from API
    },
    setLoading(state, action: PayloadAction<boolean>) {
      return { ...state, isLoading: action.payload };
    },
    setError(state, action: PayloadAction<string | null>) {
      return { ...state, error: action.payload, isLoading: true };
    },
    clearRoles(state) {
      return { ...state, roles: [], isLoading: true, error: null };
    },
    setIsSuperadmin(state, action: PayloadAction<boolean>) {
      return { ...state, isSuperadmin: action.payload };
    },
  },
});

export const { setRoles, clearRoles, setLoading, setError, setIsSuperadmin } = roleSlice.actions;
export default roleSlice.reducer;
